import {Fill, Icon, Stroke, Style} from "ol/style";
import {url} from "../../utilities";
import Circle from "ol/style/Circle";

export const selectStyle = (feature) => {

    let styleOptions;

    let sectorData = feature.get('sector-data');
    let zoneData = feature.get('type');

    if(zoneData && zoneData !== 'sector'){
        return new Style({
            image: new Circle({
                fill: new Fill({
                    color: 'rgba(117, 117, 117, 0.75)'
                }),
                stroke: new Stroke({
                    color: 'rgba(0, 0, 0, 1)'
                }),
                radius: 5
            }),
            stroke: new Stroke({
                color: 'rgba(0, 0, 0, 1)',
                lineDash: [4],
                width: 1,
                lineJoin: "bevel",
            }),
            fill: new Fill({
                color: 'rgba(117, 117, 117, 0.75)'
            })
        });

    }

    if(sectorData) {
        if (sectorData.book_records && sectorData.book_records.length > 0) {
            return new Style({
                fill: new Fill({
                    color: 'rgba(175, 22, 24, 0.4)'
                }),
                stroke: new Stroke({
                    color: '#af1618',
                    lineCap: 'butt',
                    width: 3
                }),
            })
        } else if ((sectorData.shutdowns && sectorData.shutdowns.length > 0) || sectorData.district_shutdown_from) {
            return new Style({
                fill: new Fill({
                    color: 'rgba(111, 66, 193, 0.4)'
                }),
                stroke: new Stroke({
                    color: '#6F42C1',
                    lineCap: 'butt',
                    width: 3
                }),
            })
        }
    }

    styleOptions = {
        stroke: new Stroke({
            color: 'rgb(255, 234, 3)',
            lineCap: 'butt',
            width: 3
        }),
        fill: new Fill({
            color: 'rgba(40, 115, 22, 0.2)'
        })
    };

    if (feature.get('type') === 'device') {
        styleOptions.image = new Icon({
            src: url(`images/device-type-${feature.get('device_type_id')}.png`),
            color: '#297316',
            anchor: [0.5, 1]
        })
    }

    return new Style(styleOptions);
}
